// Only authored patient mappings or an explicit, allowlisted browser hint qualify.
// Never infer identity from labels (doctor, emergency contact and payer fields can
// have the same labels as patient fields).
const MAPPING_TOKENS = {
    first_name: 'given-name', last_name: 'family-name', email: 'email',
    phone_number: 'tel', phone: 'tel', date_of_birth: 'bday',
    salutation: 'honorific-prefix', address: 'street-address',
    city: 'address-level2', postcode: 'postal-code',
};
// Reserved server-injected patient fields have no lead_mapping.
const VIRTUAL_MAPPINGS = {
    'virtual:first_name': 'first_name', 'virtual:last_name': 'last_name',
    'virtual:email': 'email', 'virtual:phone': 'phone_number',
};
const TOKENS = new Set([
    ...Object.values(MAPPING_TOKENS), 'address-line1', 'address-line2', 'country-name', 'off',
]);
const TEXT_TYPES = new Set(['text', 'textarea', 'email', 'phone']);

export function consentAutofillProps(field, { inactive = false, fallbackId } = {}) {
    const metadata = field.metadata || {};
    const identity = String(field.id ?? fallbackId ?? 'unidentified');
    const name = `consent-field-${encodeURIComponent(identity)}`;
    // An interactive form and its offscreen PDF copy can coexist.
    const id = `${name}-${encodeURIComponent(fallbackId || 'input')}`;
    const props = { id, name, autoComplete: 'off', 'aria-label': field.label || field.placeholder || 'Form field' };
    if (inactive || metadata.filled_by === 'practice') return props;
    if (field.type === 'email') props.inputMode = 'email';
    if (field.type === 'phone') props.inputMode = 'tel';
    // Confirmation must be entered separately, even if it has a mapping or hint.
    if (metadata.validations?.match_field || metadata.match_field) return props;
    const mapping = field.lead_mapping || metadata.lead_mapping || VIRTUAL_MAPPINGS[field.id];
    const explicit = metadata.autocomplete;
    const token = TOKENS.has(explicit) ? explicit : MAPPING_TOKENS[mapping];
    if (TEXT_TYPES.has(field.type) && TOKENS.has(token) && token !== 'bday') props.autoComplete = token;
    if (field.type === 'select' && ['honorific-prefix', 'country-name'].includes(token)) props.autoComplete = token;
    if (field.type === 'date' && token === 'bday') props.autoComplete = token;
    if (props.autoComplete === 'email') props.inputMode = 'email';
    if (props.autoComplete === 'tel') props.inputMode = 'tel';
    return props;
}
